import { createBundleItem } from "../../api/inventoryService";

export const useCreateBundleItem = (successCallback) => {
    const create = async (data) => {
        try {
            const newRecord = await createBundleItem(data);
            if (successCallback)
            {
                successCallback(newRecord);
            }
            return newRecord;
        } catch (error) {
            console.error("Failed to create bundle item:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};